import React, { useEffect, useState } from "react";
import { useRouteMatch, useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import {
  getPatientCondition,
  getPatientConditionForPagination,
} from "../../../../store/actions";
import FirstView from "../../Repeated-Component/FirstView";
import Pagination from "../../../Pagination";
import conditions from "../../../../assets/conditions.png";

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
const ConditionChild = ({
  getPatientCondition,
  ConditionList,
  getPatientConditionForPagination,
  history,
}) => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const params = useParams();
  const sharedToken = new URLSearchParams(location.search).get("sharedToken");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [Condition, setCondition] = useState([]);
  const [filterCondition, setFilterCondition] = useState([]);
  const [currentPage, setCuttentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const pagesNumber = Math.ceil(totalResults / 15);
  let query = useQuery().get("page");
  const nextPage = () => {
    const next = currentPage + 1;
    history.push(`${url}?page=${next}`);
  };
  const prevPage = () => {
    const prev = currentPage - 1;
    history.push(`${url}?page=${prev}`);
  };

  const specificPage = (pageNum) => {
    history.push(`${url}?page=${pageNum}`);
  };

  useEffect(() => {
    if (!query && params.patientId && sharedToken)
      getPatientCondition(params.patientId, sharedToken);
    if (!query && !params.patientId && !sharedToken) getPatientCondition();
    return () => setCondition([]);
  }, [getPatientCondition, params, sharedToken, query]);

  useEffect(() => {
    if (query)
      getPatientConditionForPagination(query, params.patientId, sharedToken);
  }, [getPatientConditionForPagination, query, sharedToken, params]);

  useEffect(() => {
    const { loading, error, data } = ConditionList;
    setLoading(loading);
    setError(error);
    if (data && data.data) {
      const list = data.data;
      setCondition(list);
      setFilterCondition(list);
      setTotalResults(data.meta.total);
      setCuttentPage(data.meta.current_page);
    }
  }, [ConditionList]);

  // useEffect(() => {
  //   renderView();
  // }, [ConditionList, renderView]);
  const renderView = () => {
    return (
      <>
        <FirstView
          headerName="Conditions"
          buttonLink={`${url}/add-conditions`}
          cardLink={`${url}/view-conditions`}
          loading={loading}
          error={error}
          data={Condition}
          filterData={filterCondition}
          setFilter={setFilterCondition}
          imageForEmptyView={conditions}
          secondTitle="Condition"
        />
        {totalResults > 15 && filterCondition.length > 10 ? (
          <Pagination
            pages={pagesNumber}
            nextPage={nextPage}
            prevPage={prevPage}
            specificPage={specificPage}
            currentPage={currentPage}
          />
        ) : (
          ""
        )}
      </>
    );
  };
  return renderView();
};
const mapStateToprops = (state) => {
  // console.log(state.patientCondition);
  return {
    ConditionList: state.patientCondition,
  };
};
export default connect(mapStateToprops, {
  getPatientCondition,
  getPatientConditionForPagination,
})(ConditionChild);
